import { GridColDef } from '@mui/x-data-grid';

import { EmailsWidget } from '../../../../../features/composableAnalytics/DerivedCharts/helper';
import { renderCellFor } from '../../helper';
import { IPostgreSubmissionDTO } from '../../submissions/types';
import { transformTableData } from '../../submissions/utils/submissionHelper';

export function getTableDataForEmails(
  widgetName: EmailsWidget,
  widgetData: IPostgreSubmissionDTO,
  frequency: string
) {
  const fieldsByTable = {
    [EmailsWidget.EMAIL_USER]: ['recruiterEmail', 'recruiterName'],
    [EmailsWidget.EMAIL_USER_ONLY]: ['recruiterEmail', 'recruiterName'],
    [EmailsWidget.EMAIL_JOB]: ['jobTitle'],
  };
  switch (widgetName) {
    case EmailsWidget.EMAIL_USER:
    case EmailsWidget.EMAIL_USER_ONLY:
    case EmailsWidget.EMAIL_JOB:
      return transformTableData(widgetData, frequency as string, fieldsByTable[widgetName]);
    default:
      return [];
  }
}

export const getColumnsForEmails = (
  widgetName: EmailsWidget,
  widgetData: IPostgreSubmissionDTO,
  frequency: string,
  tableData: any[]
): GridColDef[] => {
  const extraColumns = widgetData.response?.map((entity) => ({
    field: entity.date?.split('T')[frequency === 'HOURLY' ? 1 : 0] as string,
    headerName: entity.date?.split('T')[frequency === 'HOURLY' ? 1 : 0] + ` (${entity.count})`,
    width: 120,
  }));
  switch (widgetName) {
    case EmailsWidget.EMAIL_USER:
      return [
        {
          field: 'recruiterName',
          headerName: 'User Name',
          flex: 2,
          minWidth: 170,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'totalCount',
          headerName: `Total (${tableData.reduce(
            (accumulator, currentRow) => currentRow.totalCount + accumulator,
            0
          )})`,
          flex: 1,
          minWidth: 150,
        },
        ...(extraColumns as any[]),
      ];
    case EmailsWidget.EMAIL_USER_ONLY:
      return [
        {
          field: 'recruiterName',
          headerName: 'User Name',
          flex: 2,
          minWidth: 170,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'totalCount',
          headerName: `Total (${tableData.reduce(
            (accumulator, currentRow) => currentRow.totalCount + accumulator,
            0
          )})`,
          flex: 1,
          minWidth: 150,
        },
      ];
    case EmailsWidget.EMAIL_JOB:
      return [
        {
          field: 'jobTitle',
          headerName: 'Job Title',
          flex: 2,
          minWidth: 170,
        },
        {
          field: 'totalCount',
          headerName: `Total (${tableData.reduce(
            (accumulator, currentRow) => currentRow.totalCount + accumulator,
            0
          )})`,
          flex: 1,
          minWidth: 150,
        },
      ];
    default:
      throw new Error('Invalid table widget name');
  }
};
